import React, { useState, useEffect } from 'react';
import CalendarIcon from './icons/calendar';

const Calendar = ({
	days,
	handleChange,
	showIntervals,
	selectedOption,
	setDetails,
	classes,
}) => {
	const [iconDate, setIconDate] = useState(
		new Date().toLocaleString('ro-Ro', { month: 'long', year: 'numeric' })
	);
	const [selectedRadio, setSelectedRadio] = useState(selectedOption);
	const [isDown, setIsDown] = useState(false);
	const [startX, setStartX] = useState(0);
	const [scrollLeft, setScrollLeft] = useState(0);

	const handleMouseDown = (e) => {
		const slider = document.querySelector(`#radioDaysContainer`);
		setIsDown(true);
		setStartX(e.pageX - slider.offsetLeft);
		setScrollLeft(slider.scrollLeft);
	};
	const handleMouseLeave = (e) => {
		setIsDown(false);
	};
	const handleMouseUp = (e) => {
		setIsDown(false);
	};

	const handleMouseMove = (e) => {
		if (!isDown) return;

		e.preventDefault();
		const slider = document.querySelector(`#radioDaysContainer`);

		const x = e.pageX - slider.offsetLeft;
		const walk = (x - startX) * 3; //scroll-fast
		slider.scrollLeft = scrollLeft - walk;
	};

	//Send the first available day tot FormTinuta to update the data
	useEffect(() => {
		setDetails((prevState) => ({
			...prevState,
			ziua: days[selectedOption],
		}));
	}, []);

	//Prepare data received for de calendar
	const prepareDataFormat = (item) => {
		const [dy, date, month, year, weekend] = item
			.split(/,| /)
			.filter((el) => el != null && el != '');
		const newFormat = `${date} ${dy.slice(0, 2)}`;
		const disabled = weekend != null ? true : false;
		const calendarIcon = `${month} ${year}`;

		return [newFormat, disabled, calendarIcon];
	};

	return (
		<>
			<div className={classes['custom-form__iconDate']}>
				<CalendarIcon />
				<span>{iconDate}</span>
			</div>

			<div
				className={classes['custom-form__radio-days-container']}
				id="radioDaysContainer"
				onClick={handleChange}
				onMouseDown={handleMouseDown}
				onMouseLeave={handleMouseLeave}
				onMouseUp={handleMouseUp}
				onMouseMove={handleMouseMove}
			>
				{days.map((day, index) => {
					const [newFormat, disabled, calendarIcon] =
						prepareDataFormat(day);
					return (
						<div id={`radio${index}-container`} key={index}>
							<input
								className={classes['radio-days-input']}
								disabled={disabled}
								checked={selectedRadio == index}
								type="radio"
								value={day}
								name="ziua"
								id={`radioDay${index}`}
								onChange={() => setSelectedRadio(index)}
							/>
							<label
								className={classes['radio-days-label']}
								htmlFor={`radioDay${index}`}
								onClick={() => {
									if (!disabled) {
										setIconDate(calendarIcon);
										showIntervals(index);
									}
								}}
							>
								{newFormat}
							</label>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default Calendar;
